import { createModel } from '@rematch/core';

import type { TReadingGroup } from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { RootModel } from 'store/models';

export type TReadingGroupWithNone = TReadingGroup | 'none';

export type TLinkedCallReadingsState = {
  readingIds: {
    readingId: string;
    deviceId: string;
  }[];
  isPopupOpen: boolean;
  readingGroups: TReadingGroupWithNone[];
};

const INITIAL_STATE: TLinkedCallReadingsState = {
  readingIds: [],
  isPopupOpen: false,
  readingGroups: [],
};

const linkedCallsReadings = createModel<RootModel>()({
  state: INITIAL_STATE,
  reducers: {
    setReadingIds: (
      state,
      readingIds: { readingId: string; deviceId: string }[],
    ) => ({
      ...state,
      readingIds,
    }),
    setReadingGroups: (state, readingGroups: TReadingGroupWithNone[]) => ({
      ...state,
      readingGroups,
    }),
    resetState: () => INITIAL_STATE,
    setIsPopupOpen: (state, isPopupOpen: boolean) => ({
      ...state,
      isPopupOpen,
    }),
  },
});

export default linkedCallsReadings;
